import React from 'react'
import { SVGProps } from './types'

export const NavCookie: React.FC<SVGProps> = ({
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth = 2,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick && (() => onClick())}
    >
      <path
        d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5"
        fill="none"
      />
      <path d="M8.5 8.5v.01" fill="none" />
      <path d="M16 15.5v.01" fill="none" />
      <path d="M12 12v.01" fill="none" />
      <path d="M11 17v.01" fill="none" />
      <path d="M7 14v.01" fill="none" />
    </svg>
  )
}
